// founderApi — client API de l'espace Founder Partner (v5.9.0).
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/founder`;
const KEY = "aya_founder_token";

export const getFounderToken = () => localStorage.getItem(KEY);
export const setFounderToken = (t) => localStorage.setItem(KEY, t);
export const clearFounderToken = () => localStorage.removeItem(KEY);

export const founderApi = axios.create({ baseURL: API, timeout: 30000 });
founderApi.interceptors.request.use((cfg) => {
  const t = getFounderToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
